/*
 *   PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *    Copyright © 2019. Pearson Education, Inc.
 *    All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains
 *   the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *   herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *   patent applications, and are protected by trade secret or copyright law.
 *   Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *   is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 */
/** **** Validation Messages ***** */
var MSG_INSTITUTE_REQUIRED = 'Institution is required.';
var MSG_LMS_REQUIRED = 'Learning Management System is required.';
var MSG_ENVIRONMENT_REQUIRED = 'Environment is required.';
var MSG_FIRST_NAME_REQUIRED = 'First Name is required.';
var MSG_LAST_NAME_REQUIRED = 'Last Name is required.';
var MSG_EMAIL_REQUIRED = 'Email Address is required.';
var MSG_INVALID_EMAIL = 'Email Address is invalid.';
var MSG_2_EMAILS_ONLY = 'You cannot add more than two Additional Email Addresses.';
var MSG_INVALID_ADDITIONAL_EMAILS = 'One of the Additional Email Addresses is invalid.';
var MSG_RECAPTCHA_REQUIRED_HEADER = "You must select";
var MSG_RECAPTCHA_REQUIRED_BODY = "I'm not a robot.";
var MSG_KEYSECRET_ALREADY_GENERATED = "Keysecret already generated.";
var MSG_BASE_URL_INVALID = 'Base URL is invalid.';
var MSG_BASE_URL_REQUIRED = 'Base URL is required.';
var MSG_APP_ID_KEY_INVALID = 'Application Key or Application ID is invalid.';
var MSG_APP_ID_REQUIRED = 'Application ID is required.';
var MSG_APP_KEY_INVALID = 'Application Key is invalid.';
var MSG_APP_KEY_REQUIRED = 'Application Key is required.';
var MSG_OPT_VERIFY_YOUR_EMAIL_EXP_TITLE = "The option to verify your email expired.";
var MST_OPT_VERIFY_YOUR_EMAIL_EXP_BODY = "Either check your email for the most recent link or submit a new request.";
var MSG_OPT_GET_KEY_SECRET_EXP = "The option to get your key and secret expired.";

/** **** Orgnization Search Message ***** */
var MSG_ORG_SEARCH_NO_RESULTS = 'No results were found.';
var MSG_ORG_SEARCH_ERR = 'Try spelling or abbreviating your institution name differently. Otherwise, contact <a href="https://support.pearson.com/getsupport/s/" target="_blank">Pearson Support</a>.';
MSG_SEARCH_MIN_CHARS = '<i>Your search must contains at least <b>3</b> charactors</i>';

var TITLE_ERR = "We\'re having difficulty responding to your request.";
var MSG_ERR_KEYSTORE = 'Please try again later or contact <a href="https://support.pearson.com/getsupport/s/" target="_blank">Pearson Support</a> and give them the code: ';
var MSG_ERR_RECAPTCHA = "<p>Error occurred when contacting Google reCAPTCHA service.</p>";
var MSG_ERR_RESPONDING_DIFFICULTY_MESSAGE = 'Please refresh the page and try again or contact <a href="https://support.pearson.com/getsupport/s/" target="_blank">Pearson Support</a>.';
var MSG_ERR_APPID_APPKEY = "Application Key or Application ID is invalid.";
var serviceName = 'onboarding';
var institutions = {};

var isLink = false;

/** **** Error Codes***** */
var ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_POST = "3PLNG_KS_01";
var ERRORCODE_INACTIVE_KEYSTORESERVICE_KEY_GET = "3PLNG_KS_02";
var ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_GET = "3PLNG_KS_03";
var ERRORCODE_INACTIVE_KEYSTOREUISERVICE = "3PLNG_KS_04";
var ERRORCODE_INACTIVE_KEYSTORESERVICE_SEND_EMAIL_POST = "3PLNG_KS_05";
var ERRORCODE_INVALID_APPID_KEY = "3PLNG_LMSP_02";
var ERRORCODE_LMS_VERSION_UNSUPPORT = "3PLNG_LMSP_03";
//Error code to return when D2L proxy is down
var ERRORCODE_INACTIVE_D2L_PROXY = "3PLNG_KS_06";
//Error code to return when Blackboard proxy is down
var ERRORCODE_INACTIVE_BLACKBOARD_PROXY = "3PLNG_KS_07";


/** **** Help Message ***** */
var TITLE_BASE_URL = 'What is the Base URL?';
var HELP_TEXT_BASE_URL = 'The Base URL is used to validate your LMS instance and set up your institution to work with Pearson. <p>Example:<br>https://yoursite.website.com</p>';
var TITLE_APP_KEY = 'What is the Application Key?';
var HELP_TEXT_APP_KEY = 'The Application Key is used by Brightspace to authenticate the API call because it\'s signed by the App Key as a trusted client.';
var TITLE_APP_ID = 'What is the Application ID?';
var HELP_TEXT_APP_ID = 'The Application ID is used to validate the client, such as socket, that accesses the Brightspace API.';

/** **** Warning Message ***** */
var MSG_VERSION_NOT_SUPPORTED = 'Your institution\'s Blackboard Learn version only supports manual grade sync. The version must be 3000.5 or above to support automatic grade sync.';
var MSG_INVALID_APPID_KEY_CONFIG = 'Remember to <a href="https://help.pearsoncmg.com/integration/admin/ng/cpi_pearson_blackboard_admin_guide.pdf" target="_blank">add the Application ID and enable the Blackboard REST API authorization</a> to set up Pearson grade sync.';

/** **** Additional parameters enabled LMS types ***** */
var BASE_URL_ENABLED_LMSES = [];
var APP_ID_ENABLED_LMSES = [];
var APP_KEY_ENABLED_LMSES = [];

var modalCaller = null;
var keystoreToken = "";

/** ****APP***** */
var keyStoreUiApp = angular.module('keyStoreUiApp', ['ngRoute', 'insControllers', 'ngSanitize']);

keyStoreUiApp.config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/request/:keystoreToken', {
        templateUrl: 'static/partials/key-request-form.html',
        controller: 'FormController'
    }).when('/view/:consumerKey', {
        templateUrl: 'static/partials/view-installation-details.html',
        controller: 'ViewController'
    }).when('/secure-keystore', {
        templateUrl: 'static/partials/key-store-welcome-email.html',
        controller: 'EmailController'
    }).when('/keystore-message', {
        templateUrl: 'static/partials/keystore-message.html',
        controller: 'MessageController'
    }).when('/secure-keystore-error-message/:messageCode', {
        templateUrl: 'static/partials/keystore-error-message.html',
        controller: 'ErrorController'
    }).otherwise({
        redirectTo: '/'
    });
}]);

/** ****CONTROLLERS***** */
var insControllers = angular.module('insControllers', []);

/** **** Check if Key and Secret already exist ***** */
var changeCompositeElements = function ($scope, $location, keystoreToken) {
    // to be triggered when organizationId or lmsName or environemntType changed
    var organizationId = $('#input-organization-id').val();
    var lmsName = $('#input-lms-name').val() === '? undefined:undefined ?' ? null : $('#input-lms-name').val();
    var environment = $('#input-environment').val() === '? undefined:undefined ?' ? null : $('#input-environment').val();

    if (!(organizationId && lmsName && environment)) {
        return;
    }

    $.ajax({
        url: '/' + serviceName + '/installation',
        type: 'GET',
        headers: {
            'x-keystore-token': keystoreToken
        },
        data: {
            organizationId: organizationId,
            lmsName: lmsName,
            environment: environment
        },
        success: function (data) {
            // key and secret for the given parameters already exists.
            lockUnlockNonCompositeKeyFields(true);
            $('#view-existing-link').attr('href', '/' + serviceName + '/#/view/' + data.consumerKey);
            $('#exists-alert').show();
            $('#key-secret-request .btn-container').hide();
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {

            if (XMLHttpRequest.status === 401) {
                $location.path("/secure-keystore-error-message/MSG_OPT_GET_KEY_SECRET_EXP");
                $scope.$apply();
            } else if (XMLHttpRequest.status == 404) {
                lockUnlockNonCompositeKeyFields(false);
                $('#exists-alert').hide();
                $('#key-secret-request .btn-container').show();
            }
            else if (XMLHttpRequest.status == 424) {
                showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_GET + "</b>");
            } else {
                showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_GET + "</b>");
            }
        }
    });
};

function lockUnlockNonCompositeKeyFields(disable) {
    $('#input-first-name, #input-last-name, #input-email, #input-additional-email-addresses, #input-job-title, #input-submit')
        .prop('disabled', disable);
}

$(function () {
    $('#message-modal').modal({
        show: false
    });

/**
 * @desc Modal is shown by many events. If it is shown by a help button, return the focus back else do nothing
 */
$('#message-modal').on('hidden.bs.modal', function () {
    if(modalCaller != null){
        modalCaller.focus();
        modalCaller = null;
    }
});

});

function showMessage(title, message) {
    $(".modal-title").text(title);
    $(".modal-body").html(escapeHtml(message));
    $('#message-modal').modal("show");
}

function optionExpired() {

}

insControllers.controller('FormController', ['$rootScope', '$scope', '$http', '$location', '$routeParams', function ($rootScope, $scope, $http, $location, $routeParams) {

    keystoreToken = $routeParams.keystoreToken.trim();

    $scope.callSectionHelpText = callSectionHelpText;
    $scope.toglleBaseUrlSection = toglleBaseUrlSection;
    $scope.onValChange = function () {
        changeCompositeElements($scope, $location, keystoreToken);
    };

    hideLmsSpecificSections();

    //GET the list of Learning Management Systems
    $scope.lmses = [];
    $http({
        method: 'GET',
        url: '/' + serviceName + '/lms',
        headers: {
            'x-keystore-token': keystoreToken
        },
    }).then(function successCallback(response) {
        $scope.lmses = response.data;
    }, function errorCallback(response) {
        if (response.status === 401) {
            $location.path("/secure-keystore-error-message/MSG_OPT_GET_KEY_SECRET_EXP");
            $scope.$apply();
        }
    });

    //GET the list of environments
    $scope.environments = [];
    $http({
        method: 'GET',
        url: '/' + serviceName + '/environment',
        headers: {
            'x-keystore-token': keystoreToken
        },
    }).then(function successCallback(response) {
        $scope.environments = response.data;
    }, function errorCallback(response) {
        if (response.status === 401) {
            $location.path("/secure-keystore-error-message/MSG_OPT_GET_KEY_SECRET_EXP");
            $scope.$apply();
        }
    });

    //GET the list of baseurl enabled lmses
    $scope.baseUrlEnabledLmses = [];
    $http({
        method: 'GET',
        url: '/' + serviceName + '/additionalparamsenabledlms',
        headers: {
            'x-keystore-token': keystoreToken
        },
    }).then(function successCallback(response) {
        BASE_URL_ENABLED_LMSES = response.data.baseUrl;
        APP_ID_ENABLED_LMSES = response.data.appId;
        APP_KEY_ENABLED_LMSES = response.data.appKey;
    }, function errorCallback(response) {
        if (response.status === 401) {
            $location.path("/secure-keystore-error-message/MSG_OPT_GET_KEY_SECRET_EXP");
            $scope.$apply();
        }
    });

    $scope.installation = { keyStoreExtendedPropertiesDTO: { extendedProperties: {} } };
    $scope.installationRequest = function () {

        if ($scope.installation != undefined) {

            /*if ($scope.installation.baseUrl != undefined) {
                $scope.installation.baseUrl = $('#input-base-url').val().trim();
            }*/

            if ($scope.installation.keyStoreExtendedPropertiesDTO.extendedProperties.baseURL) {
                $scope.installation.keyStoreExtendedPropertiesDTO.extendedProperties.baseURL = $('#input-base-url').val().trim();
            }

            if ($scope.installation.keyStoreExtendedPropertiesDTO.extendedProperties.appId) {
                $scope.installation.keyStoreExtendedPropertiesDTO.extendedProperties.appId = $('#input-appId').val().trim();
            }

            if ($scope.installation.keyStoreExtendedPropertiesDTO.extendedProperties.appKey) {
                $scope.installation.keyStoreExtendedPropertiesDTO.extendedProperties.appKey = $('#input-appKey').val().trim();
            }

            if ($scope.installation.instituteInstallation != undefined) {
                if((APP_KEY_ENABLED_LMSES.indexOf($scope.installation.instituteInstallation.lmsName) === -1)) {
                    delete $scope.installation.keyStoreExtendedPropertiesDTO.extendedProperties.appId;
                    delete $scope.installation.keyStoreExtendedPropertiesDTO.extendedProperties.appKey;
                }
                $scope.installation.instituteInstallation.organizationId = $('#input-organization-id').val();
                $scope.installation.instituteInstallation.institutionName = $('#input-institution-name').val();

            }

            if ($scope.installation.administrator != undefined && $scope.installation.administrator.additionalEmailAddresses != undefined) {
                if (typeof $scope.installation.administrator.additionalEmailAddresses == 'string' && $scope.installation.administrator.additionalEmailAddresses.trim().length > 0) {
                    $scope.installation.administrator.additionalEmailAddresses = $scope.installation.administrator.additionalEmailAddresses.trim().split(',');
                    for (i = 0; i < $scope.installation.administrator.additionalEmailAddresses.length; i++) {
                        $scope.installation.administrator.additionalEmailAddresses[i] = $scope.installation.administrator.additionalEmailAddresses[i].trim();
                    }
                } else {
                    $scope.installation.administrator.additionalEmailAddresses = [];
                }
            }
        }

        if (validate($scope.installation)) {
            focusFirstError();
            return;
        }

        if ($("textarea[name='g-recaptcha-response']") && $("textarea[name='g-recaptcha-response']").val()) {
            recaptchaResponse = $("textarea[name='g-recaptcha-response']").val();
        } else {
            recaptchaResponse = '';
        }

        //disable the submit button
        $('#btnKeySecretRequestSubmit').prop('disabled', true);

        //Create new Key and Secret
        $http.post(('/' + serviceName + '/installation'),
            $scope.installation, {
                headers: {
                    'x-recaptcha-response': recaptchaResponse,
                    'x-keystore-token': keystoreToken
                }
            }, {
                timeout: 60000
            }).success(function (data) {
                //enable the submit button
                $('#btnKeySecretRequestSubmit').prop('disabled', false);

                console.log(data);

                if (data.consumerKey) {
                    $rootScope.installation = data;
                    $location.path("/view/" + data.consumerKey);
                }

            }).error(function (data, status) {
                //enable the submit button
                $('#btnKeySecretRequestSubmit').prop('disabled', false);

                if (status === 401) {
                    $location.path("/secure-keystore-error-message/MSG_OPT_GET_KEY_SECRET_EXP");
                    $scope.$apply();

                } else if(status === 500){

                } else if(status === 424){
                    if(data.message === "D2lProxyError"){
                        showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_D2L_PROXY + "</b>");
                    } else if(data.message === "ERROR_BB_PROXY_LMS_DATA_VALIDATION"){
                        showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_BLACKBOARD_PROXY + "</b>");
                    } else if(data.message === "InvalidPayload"){
                        showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_POST + "</b>");
                    }

                } else if (data.error) {

                    switch (data.error) {
                        case "3PLNG_LMSP_01":
                            baseUrlInvalidMessage();
                            focusFirstError();
                            break;
                        case "3PLNG_LMSP_02":
                            appIdKeyInvalidMessage();
                            focusFirstError();
                            break;
                        case "keysAlreadyGenerated":
                            showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + MSG_KEYSECRET_ALREADY_GENERATED + "</b>");
                            break;
                        case "KeyStoreDatabaseFailer":
                            showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_POST + "</b>");
                            break;
                        case "KeyStoreServiceFailer":
                            showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_POST + "</b>");
                            break;
                        case "KeyStoreCaptchaFailer":
                            showMessage(TITLE_ERR, MSG_ERR_RESPONDING_DIFFICULTY_MESSAGE);
                            break;
                        default:
                            showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_POST + "</b>");
                    }
                } else {
                    showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_POST + "</b>");
                }

            });
    };
    activateLiveSearch($scope, $location, keystoreToken);
    $('input').tooltip();

    $('input').on('shown.bs.tooltip hide.bs.tooltip hidden.bs.tooltip', function () {
        $('#input-institution').attr('aria-describedby', 'combobox-help-text1');
    });

    //typing on all inputs remove its corrosponding error
    $('body').on('keyup', 'input', function (e) {
        //ignore TAB ENTER and SHIFT keys
        if (e.which == 9 || e.which == 13 || e.which == 16)
            return;
        hideOwnError($(this));
    });

    //remove error on all the select tags in any change
    $('body').on('change', 'select', function () {
        hideOwnError($(this));
    });

    //remove error on both app id and app key fields when one of them is changed
    $('body').on('keyup', '#input-appId, #input-appKey', function(){
        //hideOwnError($('#input-appId'));
        //hideOwnError($('#input-appKey'));
    });
}]);

insControllers.controller('ViewController', ['$rootScope', '$scope', '$http', '$routeParams', "$location", function ($rootScope, $scope, $http, $routeParams, $location) {

    $scope.warning = $rootScope.installation.error;
    $scope.configError = ERRORCODE_INVALID_APPID_KEY;
    $scope.versionError = ERRORCODE_LMS_VERSION_UNSUPPORT;
    $scope.configErrorMsg = MSG_INVALID_APPID_KEY_CONFIG;
    $scope.versionErrorMsg = MSG_VERSION_NOT_SUPPORTED;

    $http.get(('/' + serviceName + '/installation/' + $routeParams.consumerKey), {
        headers: {
            'x-keystore-token': keystoreToken
        }
    }).then(function successCallback(response) {
        $scope.installation = response.data;
    }, function errorCallback(response) {

        switch (response.status) {
            case 401:
                $location.path("/secure-keystore-error-message/MSG_OPT_GET_KEY_SECRET_EXP");
                $scope.$apply();
                break;
            case 424:
                showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_GET + "</b>");
                break;
            default:
                showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_GET + "</b>");
        }
    });
}]);

insControllers.controller('lmsController', ['$scope', '$http', '$location', function ($scope, $http, $location) {
    $scope.selectedLms = null;
    $scope.lmses = [];

    $http({
        method: 'GET',
        url: '/' + serviceName + '/lms',
        headers: {
            'x-keystore-token': keystoreToken
        }
    }).then(function successCallback(response) {
        $scope.lmses = response.data;
    }, function errorCallback(response) {
        if (response.status === 401) {
            $location.path("/secure-keystore-error-message/MSG_OPT_GET_KEY_SECRET_EXP");
            $scope.$apply();
        }
    });
}]);

insControllers.controller('MessageController', ['$scope', '$http', '$routeParams', function ($scope, $http, $routeParams) {

}]);

insControllers.controller('FlashScreenController', ['$scope', '$http', '$routeParams', function ($scope, $http, $routeParams) {

}]);

insControllers.controller('ErrorController', ['$scope', '$http', '$routeParams', function ($scope, $http, $routeParams) {
    $scope.returnUrl = '/' + serviceName + '/#/secure-keystore';

    var messageCode = $routeParams.messageCode.toLowerCase();
    switch (messageCode) {
        case "msg_opt_get_key_secret_exp":
            $scope.errorHeading = "";
            $scope.errorMessage = MSG_OPT_GET_KEY_SECRET_EXP;
            break;
        case "msg_opt_verify_your_email_exp":
            $scope.errorHeading = MSG_OPT_VERIFY_YOUR_EMAIL_EXP_TITLE;
            $scope.errorMessage = MST_OPT_VERIFY_YOUR_EMAIL_EXP_BODY;
            break;
        default:
            $scope.errorMessage = "";
    }

}]);

insControllers.controller('EmailController', ['$rootScope', '$scope', '$http', '$location', function ($rootScope, $scope, $http, $location) {
    $scope.secureemail = {};
    $scope.secureemailRequest = function () {
        if ($scope.secureemail != undefined) {
            if ($scope.secureemail.emailAddress != undefined) {
                $scope.secureemail.emailAddress = $('#input-secure-email').val();
            }
        }

        if (validateSecureEmail($scope.secureemail)) {
            return;
        }

        if ($("textarea[name='g-recaptcha-response']") && $("textarea[name='g-recaptcha-response']").val()) {
            recaptchaResponse = $("textarea[name='g-recaptcha-response']").val();
        } else {
            recaptchaResponse = '';
        }

        // disable the submit button
        $('#btnValidateEmailSubmit').prop('disabled', true);

        $http.post(('/' + serviceName + '/sendemail'), $scope.secureemail, {
            headers: {
                'x-recaptcha-response': recaptchaResponse
            }
        }, {
                timeout: 20000
            }).success(function (data) {
                $('#btnValidateEmailSubmit').prop('disabled', false);
                $location.path("/keystore-message/");
            }).error(function (data) {
                $('#btnValidateEmailSubmit').prop('disabled', false);
                if (data.status === 412) {
                    showMessage(TITLE_ERR, MSG_ERR_RESPONDING_DIFFICULTY_MESSAGE);
                }
                else if (data.status === 503 || data.status === 500 || data.status === 400 || data.status === 424) {
                    showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_SEND_EMAIL_POST + "</b>");
                }
            });
    };
}]);


//---------Live search instead of MarcoPolo

function activateLiveSearch($scope, $location, keystoreToken) {
    var selectedIndex = -1;
    selectedValue = null;
    selectedName = null;
    selectedOrgId = null;

    $('#input-institution').keydown(function (e) {
        //select search results downwards, down arrow
        if (e.which == 40) {
            e.preventDefault();
            selectedIndex = (selectedIndex >= $(this).parent().find('.list-group button').length - 1) ? 0 : selectedIndex + 1;
            $(this).parent().find('.list-group button').removeClass('active');
            $(this).parent().find('.list-group button').eq(selectedIndex).addClass('active');
            return;
        }

        //select search results upwards, up arrow
        if (e.which == 38) {
            e.preventDefault();
            $(this).parent().find('.list-group button').removeClass('active');
            selectedIndex = selectedIndex == 0 ? ($(this).parent().find('.list-group button').length - 1) : selectedIndex - 1;
            $(this).parent().find('.list-group button').eq(selectedIndex).addClass('active');
            return;
        }

        //accept the selected element, enter
        if (e.which == 13) {
            var ele = $(this).parent().find('.active');
            ele.focus();
            selectedValue = ele.text();
            selectedName = ele.attr("data-organizationName");
            selectedOrgId = ele.attr("data-organizationId");
            $('#input-institution').val(selectedValue);
            $('#input-institution').attr('data-original-title', selectedValue == null ? '' : selectedValue);
            $('#input-organization-id').val(selectedOrgId);
            $('#input-institution-name').val(selectedName);

            setTimeout(function () {
                $('#searchResults').html('');
                $('#searchResults').removeClass('list-group');
            }, 100);
        }

        //press escape for hide thr instant search dropdown
        if (e.which == 27) {
            $('#input-institution').val(selectedValue);
            $('#input-institution').attr('data-original-title', selectedValue == null ? '' : selectedValue);
            $('#input-institution-name').val(selectedName);

            setTimeout(function () {
                $('#searchResults').html('');
                $('#searchResults').removeClass('list-group');
                hideSearchError();
            }, 100);
        }
    });

    //start searching in a keyup
    $('#input-institution').keyup(function (e) {

        selectedOrgId = null;
        selectedName = null;

        //but avoid accesibility keys doing the search, down, up and enter keys do nothing
        // do nothing
        if ((e.which == 40) || (e.which == 38) || (e.which == 13))
            return;

        //length > 2
        if ($.trim($(this).val()).length <= 2) {
            $('#searchResults').html('');
            $('#searchResults').removeClass('list-group');
            showSearchError(MSG_SEARCH_MIN_CHARS);
            selectedValue = null;
            selectedOrgId = null;
            selectedName = null;
            selectedIndex = -1;
            return;
        }

        hideSearchError();
        //show spinner
        $('#institute-search-spinner').show();

        //do ajax, we can set headers here.
        $.ajax({
            type: "GET",
            url: '/' + serviceName + '/organizations',
            headers: {
                'x-keystore-token': keystoreToken
            },
            data: {
                "search": $.trim($(this).val())
            },
            success: function (data) {
                //fill search
                institutions = data;
                fillSearchDropdown(institutions);
                //hide spinner
                $('#institute-search-spinner').hide();
            },
            error: function (data) {
                if (data.status === 401) {
                    $location.path("/secure-keystore-error-message/MSG_OPT_GET_KEY_SECRET_EXP");
                    $scope.$apply();
                } else if (data.status === 417) {
                    showSearchError(MSG_ORG_SEARCH_ERR);
                    //hide spinner
                    $('#institute-search-spinner').hide();
                }
                else {
                    showMessage(TITLE_ERR, MSG_ERR_KEYSTORE + "<b> " + ERRORCODE_INACTIVE_KEYSTORESERVICE_INSTITUTE_POST + "</b>");
                    $('#institute-search-spinner').hide();
                }
            }
        });
    });

    //deligated event to select a searched item
    $('body').on("mousedown", ".list-group-item", function () {
        selectedValue = $(this).text();
        selectedName = $(this).attr("data-organizationName");
        selectedOrgId = $(this).attr("data-organizationId");
        $('#input-institution').val(selectedValue);
        $('#input-institution').attr('data-original-title', selectedValue);
        $('#input-organization-id').val(selectedOrgId);
        $('#input-institution-name').val(selectedName);


    });

    //remove any unmatched garbage values from institution name
    $('#input-institution').blur(function (e) {
        e.preventDefault();
        hideSearchError();
        $('#input-institution').val(selectedValue);
        $('#input-institution').attr('data-original-title', selectedValue == null ? '' : selectedValue);
        $('#input-institution-name').val(selectedName);

        setTimeout(function () {
            $('#searchResults').html('');
            $('#searchResults').removeClass('list-group');
            hideSearchError();
        }, 100);
    });

    //open link in the mouse down and hide message
    $('body').on("mousedown", "#searchError a", function (e) {
        e.preventDefault();
        isLink = true;
        window.open($(this).attr('href'));
        $('#searchError').hide();
    });

    //open the link on enter key down.
    $('body').on("keydown", "#searchError a", function (e) {
        e.preventDefault();
        if (e.which != 13)
            return;
        window.open($(this).attr('href'));
        $('.searchError').hide();
    });

    //on link get blured hide the message
    $('body').on("blur", "#searchError a", function () {
        $('#searchError').hide();
    });

}

//fill search suggestions dropdown
//bootstrap list group with buttons
function fillSearchDropdown(data) {
    var orgNameLocation = null;

    if (data.length == 0) {
        $('#searchResults').html('');
        $('#searchResults').removeClass('list-group');
        showSearchError(MSG_ORG_SEARCH_NO_RESULTS);
    } else {
        hideSearchError();
        var append = '';
        $('#searchResults').addClass('list-group');

        data.forEach(function (item) {
            if (item.institutionName == null)
                return;
            orgNameLocation = prepareName(item.institutionName) + (((item.state == null) || (item.state === "")) ? '' : (' - ' + prepareState(item.state))) +
                (((item.city == null) || (item.city === "")) ? '' : (', ' + prepareCity(item.city))) +
                (((item.country == null) || (item.country === "")) ? '' : (', ' + prepareCountry(item.country)));
            append += '<button type="button" data-organizationId="' + item.organizationId + '" data-organizationName="' + prepareName(item.institutionName) + '" class="list-group-item list-group-item-action">' + $("<div/>").html(orgNameLocation).text() + '</button>';
            $('#searchResults').html(append);

        });
    }
}

//
function prepareName(name) {
    if (name == null)
        return;
    return name.replace(/&*\w\S*/g, function (txt) {
        //lowercase the articles
        if (/\bAN\b|\bOF\b|\bON\b|\bIN\b|\bTHE\b|\bTHIS\b|\bTHAT\b|\b&amp\b/.test(txt))
            return txt.toLowerCase();
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}


function prepareCity(name) {
    if (name == null)
        return "";
    return name.replace(/&*\w\S*/g, function (txt) {
        //Capitaliza the abbriviations in the location with three letters
        if (txt.length <= 2)
            return txt.toUpperCase();
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}


function prepareState(name) {
    if (name == null)
        return "";
    return name.replace(/&*\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

function prepareCountry_SKIPPED(name) {
    if (name == null)
        return "";
    //Capitaliza the abbriviations in the location with three letters
    if (name.trim().length <= 3)
        return name.toUpperCase().trim();

    preparedName = "";
    name.replace(/&*\w\S*/g, function (txt) {
        if (/\ban\b|\bof\b|\bon\b|\bin\b|\bthe\b/.test(txt))
            preparedName += txt.toLowerCase();
        else
            preparedName += txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        preparedName += " ";
    });
    return preparedName.trim();
}

function prepareCountry(name) {
    if (name == null)
        return "";
    return name.toUpperCase();
}


function hideSearchError() {
    if (($('#searchError').find("a").is(':focus'))) {
        $('#searchError').show();
    } else if (!isLink)
        $('#searchError').hide();
    else
        $('#searchError').hide();
    isLink = false;
}

function showSearchError(msg) {
    $('#searchError').html(msg);
    $('#searchError').show();
}


function removeValidateMessageBody() {
    $(
        "#input-institution-error, #input-lms-name-error, #input-environment-error, #input-first-name-error, #input-last-name-error, #input-email-error, #input-additional-email-addresses-error, #recaptcha-container-error, #input-base-url-div")
        .parent().removeClass("has-error");
    $(
        "#input-institution-error, #input-lms-name-error, #input-environment-error, #input-first-name-error, #input-last-name-error, #input-email-error, #input-additional-email-addresses-error, #recaptcha-container-error, #input-base-url-error")
        .empty();
}

function validate(data) {
    var error = false;
    var errorClass = "form-group has-error";
    removeValidateMessageBody();

    if ($('#input-institution').val().trim() == '') {
        error = true;
        $('#input-institution-error').parent().addClass(errorClass);
        $('#input-institution-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_INSTITUTE_REQUIRED)));
    }

    if (data.instituteInstallation == undefined || data.instituteInstallation.lmsName == undefined || data.instituteInstallation.lmsName.trim().length == 0) {
        error = true;
        $('#input-lms-name-error').parent().addClass(errorClass);
        $('#input-lms-name-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_LMS_REQUIRED)));
    }

    if ($('#input-environment').val().trim() == '') {
        error = true;
        $('#input-environment-error').parent().addClass(errorClass);
        $('#input-environment-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_ENVIRONMENT_REQUIRED)));
    }

    if (data.administrator == undefined || data.administrator.firstName == undefined || data.administrator.firstName.trim().length == 0) {
        error = true;
        $('#input-first-name-error').parent().addClass(errorClass);
        $('#input-first-name-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_FIRST_NAME_REQUIRED)));
    }

    if (data.administrator == undefined || data.administrator.lastName == undefined || data.administrator.lastName.trim().length == 0) {
        error = true;
        $('#input-last-name-error').parent().addClass(errorClass);
        $('#input-last-name-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_LAST_NAME_REQUIRED)));
    }

    if (data.administrator == undefined || data.administrator.emailAddress == undefined || data.administrator.emailAddress.trim().length == 0) {
        error = true;
        $('#input-email-error').parent().addClass(errorClass);
        $('#input-email-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_EMAIL_REQUIRED)));
    } else if (data.administrator == undefined || data.administrator.emailAddress == undefined || !validateEmail(data.administrator.emailAddress.trim())) {
        error = true;
        $('#input-email-error').parent().addClass(errorClass);
        $('#input-email-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_INVALID_EMAIL)));
    }

    if (data.administrator != undefined && data.administrator.additionalEmailAddresses != undefined && data.administrator.additionalEmailAddresses) {
        var emailFormatErrors = false;

        for (i = 0; i < data.administrator.additionalEmailAddresses.length; i++) {
            if (!validateEmail(data.administrator.additionalEmailAddresses[i])) {
                //commit
                emailFormatErrors = true;
                break;
            }
        }

        if ((data.administrator.additionalEmailAddresses.length > 2)) {
            if (emailFormatErrors) {
                error = true;
                $('#input-additional-email-addresses-error').parent().addClass("form-group has-error");
                $('#input-additional-email-addresses-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label'));
                $('#input-additional-email-addresses-error div').html(escapeHtml(MSG_2_EMAILS_ONLY));
                $('#input-additional-email-addresses-error div').append("<br/>");
                $('#input-additional-email-addresses-error div').append(escapeHtml(MSG_INVALID_ADDITIONAL_EMAILS));
            } else {
                error = true;
                $('#input-additional-email-addresses-error').parent().addClass(errorClass);
                $('#input-additional-email-addresses-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label'));
                $('#input-additional-email-addresses-error div').html(escapeHtml(MSG_2_EMAILS_ONLY));

            }
        } else if (emailFormatErrors) {
            error = true;
            $('#input-additional-email-addresses-error').parent().addClass(errorClass);
            $('#input-additional-email-addresses-error').append($('<div></div>').attr('role', 'alert').attr('class', 'control-label'));
            $('#input-additional-email-addresses-error div').append(escapeHtml(MSG_INVALID_ADDITIONAL_EMAILS));
        }

    }

    if (!($("textarea[name='g-recaptcha-response']") && $("textarea[name='g-recaptcha-response']").val())) {
        error = true;
        $('#recaptcha-container-error').parent().addClass(errorClass);
        $('#recaptcha-container-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_RECAPTCHA_REQUIRED_HEADER) + ' <b>' + escapeHtml(MSG_RECAPTCHA_REQUIRED_BODY) +'</b>'));
    }

    if (data.instituteInstallation !== undefined && data.instituteInstallation.lmsName !== undefined && data.instituteInstallation.lmsName != null && data.instituteInstallation.lmsName.trim().length > 0) {

        var baseUrl = $('#input-base-url').val();
        if((APP_KEY_ENABLED_LMSES.indexOf(data.instituteInstallation.lmsName) === -1)) {
            $('#input-appKey').val('');
            $('#input-appId').val('');
        }
        var appKey = $('#input-appKey').val();
        var appId = $('#input-appId').val();
        var divEle;

        if ((BASE_URL_ENABLED_LMSES.indexOf(data.instituteInstallation.lmsName) != -1) && (baseUrl != undefined)) {
            divEle = $('#input-base-url-div');
            if (baseUrl.length > 0 && baseUrl.trim() !== '') {
                if (!baseUrlValidation(baseUrl)) {
                    error = true;
                    divEle.parent().addClass(errorClass);
                    $('#input-base-url-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_BASE_URL_INVALID)));
                }
            } else {
                error = true;
                divEle.parent().addClass(errorClass);
                $('#input-base-url-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_BASE_URL_REQUIRED)));
            }
        }

        if ((APP_KEY_ENABLED_LMSES.indexOf(data.instituteInstallation.lmsName) != -1) && (appKey != undefined) ) {
            divEle = $('#input-appKey-div');
            if (appKey.length == 0 || appKey.trim() == '') {
                error = true;
                divEle.parent().addClass(errorClass);
                $('#input-appKey-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_APP_KEY_REQUIRED)));
            }
        }

        if ((APP_ID_ENABLED_LMSES.indexOf(data.instituteInstallation.lmsName) != -1) && (appId != undefined)) {
            divEle = $('#input-appId-div');
            if (appId.length == 0 || appId.trim() == '') {
                error = true;
                divEle.parent().addClass(errorClass);
                $('#input-appId-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_APP_ID_REQUIRED)));
            }
        }

    }

    return error;
}

function baseUrlInvalidMessage() {
    var errorClass = "form-group has-error";
    var divEle = $('#input-base-url-div');
    divEle.parent().addClass(errorClass);
    $('#input-base-url-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_BASE_URL_INVALID)));
}

function appIdKeyInvalidMessage() {
    var errorClass = "form-group has-error";
    $('#input-appId-div').parent().addClass(errorClass);
    $('#input-appKey-div').parent().addClass(errorClass);
    $('#input-appId').focus();
    $('#input-appId-error, #input-appKey-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_APP_ID_KEY_INVALID)));
}

function removeValidateSecureEmailBody() {
    $("#input-secure-email-error, #recaptcha-container-error").parent().removeClass("has-error");
    $("#input-secure-email-error, #recaptcha-container-error").empty();
}

function validateSecureEmail(data) {
    var error = false;
    var errorClass = "form-group has-error";
    removeValidateSecureEmailBody();

    if (data.emailAddress == undefined || data.emailAddress == undefined || data.emailAddress.trim().length == 0) {
        error = true;
        $('#input-secure-email-error').parent().addClass(errorClass);
        $('#input-secure-email-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_EMAIL_REQUIRED)));
    } else if (data.emailAddress == undefined || data.emailAddress == undefined || !validateEmail(data.emailAddress.trim())) {
        error = true;
        $('#input-secure-email-error').parent().addClass(errorClass);
        $('#input-secure-email-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(escapeHtml(MSG_INVALID_EMAIL))));
    }

    if (!($("textarea[name='g-recaptcha-response']") && $("textarea[name='g-recaptcha-response']").val())) {
        error = true;
        $('#recaptcha-container-error').parent().addClass(errorClass);
        $('#recaptcha-container-error').html($('<div></div>').attr('role', 'alert').attr('class', 'control-label').html(escapeHtml(MSG_RECAPTCHA_REQUIRED_HEADER) + ' <b>' + escapeHtml(MSG_RECAPTCHA_REQUIRED_BODY) +'</b>'));
    }
    return error;
}

function escapeHtml(unsafe) {
    return unsafe
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
 }

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function hasSymbols(str) {
    var pattern = /[-!\#@$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
    return pattern.test(str);
}

function setEmailError() {
    var val = document.getElementById('emailAddress').value;
    if (val.trim().length == 0) {
        document.getElementById('error-email').innerHTML = escapeHtml(MSG_EMAIL_REQUIRED);
        return false;
    } else if (validateEmail(val)) {
        document.getElementById('error-email').innerHTML = '';
    } else {
        document.getElementById('error-email').innerHTML = escapeHtml(MSG_INVALID_EMAIL);
        return false;
    }
}

function focusFirstError() {
    var errorFields = null;
    errorFields = $('#key-secret-request').find('.has-error input, .has-error select');
    if(errorFields[0] != undefined){
        errorFields[0].focus();
    }
}

var hideLmsSpecificSections = function () {
    $('#secLmsRelatedData').children("fieldset").hide();
};

var callSectionHelpText = function (element, $event) {
    $event.preventDefault();
    var keyCode = $event.which || $event.keyCode;

    if(keyCode === 13 || $event.type=="click"){
        var lmsName = $('#input-lms-name option:selected').text() === '' ? "LMS" : $('#input-lms-name option:selected').text();

        if (element == 'baseUrl') {
            showMessage(TITLE_BASE_URL, HELP_TEXT_BASE_URL.replace("LMS", lmsName));
        } else if (element == 'appId') {
            showMessage(TITLE_APP_ID, HELP_TEXT_APP_ID.replace("LMS", lmsName));
        } else if (element == 'appKey') {
            showMessage(TITLE_APP_KEY, HELP_TEXT_APP_KEY.replace("LMS", lmsName));
        }
        modalCaller = $event.target;
    }
};



function baseUrlValidation(url) {
    var regexp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    var flag = regexp.test(url);

    return flag;
}

function appIdValidation(id){
    return true;
}

function appKeyValidation(key){
    return true;
}

//find the immidiate parent fieldset and remove its has-error class
//remove the content in the div element where its id has a text 'error'
function hideOwnError(element) {
    element.closest('fieldset').removeClass('has-error');
    element.closest('fieldset').find("div[id*='error']").empty();
}

function hideAllErrors() {
    $('#key-secret-request').find('.has-error').removeClass('has-error');
}

var toglleBaseUrlSection = function () {
    var lmsName = $('#input-lms-name').val() === '? undefined:undefined ?' ? null : $('#input-lms-name').val();
    var sectionsToShow = [];

    hideLmsSpecificSections();

    if (BASE_URL_ENABLED_LMSES.indexOf(lmsName) != -1) {
        sectionsToShow.push($('#base-url-section'));
    }
    if (APP_ID_ENABLED_LMSES.indexOf(lmsName) != -1) {
        sectionsToShow.push($('#appId-section'));
    }
    if (APP_KEY_ENABLED_LMSES.indexOf(lmsName) != -1) {
        sectionsToShow.push($('#appKey-section'));
    }

    //room for more additional parameters

    $.each(sectionsToShow, function (index, element) {
        element.show();
    });

};
